import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { jointInsert, jointList, jointUpdate } from "../../../Redux/Actions";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import usePermissions from "../../Common/Functions/usePermissions";

const JointForm = () => {
  const dispatch = useDispatch();
  const { jointSingle } = useSelector((state) => state.Joint);
  // Permissions
  const addPermission = usePermissions(Constants.permission.BODY_PART_ADD);
  const editPermission = usePermissions(Constants.permission.BODY_PART_EDIT);

  // Initial values to Joint form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for Joint form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill jointSingle form
    if (jointSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (jointSingle[key]) {
          editValue[key] = jointSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [jointSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update jointSingle API
        let submitFunc = jointInsert(values);
        if (jointSingle._id) {
          values.id = jointSingle._id;
          submitFunc = jointUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.JOINT_SINGLE, payload: "" });
            dispatch({ type: types.JOINT_FORM_MODEL, payload: "" });
          }
          dispatch(jointList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !jointSingle?._id) ||
            (editPermission && jointSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default JointForm;
